/*
* JavaScript常用工具类
*/
/* eslint-disable */
export default {
  /**
 * 截取字符串 中英文混合
 *  str	待处理字符串
 *  len	截取字节长度 中文2字节 英文1字节
 *  add 是否加上...
 */
  subString(str, len, add) {
    var regexp = /[^\x00-\xff]/g // 正在表达式匹配中文
    var emoji =
      /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig

    if (str == null) {
      return
    }
    if (typeof str !== 'string') {
      str = str.toString()
    }
    // 当字符串字节长度小于指定的字节长度
    if (str.replace(regexp, 'aa').length <= len) {
      return str
    }

    str = str.replace(emoji, '') // 方案一 删除全部表情
    // 假设指定长度内都是中文
    var m = Math.floor(len / 2)
    for (var i = m, j = str.length; i < j; i++) {
      // 当截取字符串字节长度满足指定的字节长度
      if (str.substring(0, i).replace(regexp, 'aa').length >= len) {
        if (!add) {
          var return_str = str.substring(0, i)
          var last_str = return_str.substring(return_str.length - 1, return_str.length)
          if (this.charToUnicode(last_str) == '/ud83d') {
            // if(emoji.test(charToUnicode(last_str))){ //方案2 表情和文字共存
            var return_str = str.substring(0, i - 1)
          };
          return return_str + '...'
          //  return_str.replace(emoji,'[图标]')
        } else {
          return str.substring(0, i)
        }
      }
    }
    return str
  },
  /**
  * 时间转换
  *  time	传入时间
  *  type '-'  或者 '/'
  */

  time(time, type) {
    let getFullYear = time.getFullYear();
    let getMonth = time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1;
    let getDate = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
    let getHours = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
    let getMinutes =
      time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
    let getSeconds =
      time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
    let datetime = `${getFullYear}${type}${getMonth}${type}${getDate} ${getHours}:${getMinutes}:${getSeconds}`
    return datetime;
  }


}



// WEBPACK FOOTER //
// ./src/utils/util.js